import {Link, useNavigate, useLocation } from 'react-router-dom';
import logo from './img/logo.png';
import downloadImg from '../img/download.svg';


import "./style.css";
import {installPromt, userChoise} from "../serviceWorkerRegistration";
import {useEffect, useRef} from "react";
import {useState} from "react";

const Navbar = ({scrolling}) => {
    const [show, setShow] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const myRef = useRef()
    const [scrollTable, setScrollTable] = scrolling


    return (
        <div>
            <nav className="navbarapp navbar d-flex justify-content-between"
                 style={{width: '100%', margin: '0', zIndex: '1'}}>
                <img src={logo} style={{cursor: 'pointer'}} className='applogo navbar-brand' onClick={() => {
                    setShow(true)
                    if (location.pathname !== "/") {
                        navigate('/')
                        setScrollTable('cur')
                    } else {
                        setScrollTable('cur')
                    }
                    for (var i = 0; i < document.getElementsByClassName('animationToTop').length; i++) {
                        if (i == 0) {
                            document.getElementsByClassName('animationToTop')[i].style.transform = 'translateY(-15px)'
                            document.getElementsByClassName('textTab')[i].style.opacity = '1'
                        } else {
                            document.getElementsByClassName('animationToTop')[i].style.transform = 'translateY(0)'
                            document.getElementsByClassName('textTab')[i].style.opacity = '0'
                        }
                    }
                }}></img>
                <div className={"navcontent"}>
                    <h1 className='appname' style={{cursor: 'pointer'}} ref={myRef} onClick={(e) => {
                        setShow(true)
                        if (location.pathname !== "/") {
                            navigate('/')
                            setScrollTable('cur')
                        } else {
                            setScrollTable('cur')
                        }
                        for (var i = 0; i < document.getElementsByClassName('animationToTop').length; i++) {
                            if (i == 0) {
                                document.getElementsByClassName('animationToTop')[i].style.transform = 'translateY(-15px)'
                                document.getElementsByClassName('textTab')[i].style.opacity = '1'
                            } else {
                                document.getElementsByClassName('animationToTop')[i].style.transform = 'translateY(0)'
                                document.getElementsByClassName('textTab')[i].style.opacity = '0'
                            }
                        }
                    }}>صرافی مجتهدی</h1>
                    <span style={{
                        margin: '0',
                        fontSize: '12px',
                        fontWeight: '900'
                    }}>با مجوز رسمی از بانک مرکزی جمهوری اسلامی ایران</span>
                </div>
                <div style={{width: "fit-content"}}>
                    <img onClick={(e) => {
                        installPromt(e)
                    }} className="ml-1 mr-1 disp" style={{cursor: "pointer" , width:"30px"}} src={downloadImg}/>
                </div>

            </nav>

        </div>
    );
}

export default Navbar;